import { lazy } from 'react'
import IRoute from '../types/routes.types'

// Carga diferida (code-splitting): cada página va en su propio chunk y solo se
// descarga/parsea al entrar en su ruta. Esto saca del bundle inicial librerías
// pesadas (react-pdf, recharts, xlsx, etc.) que antes se parseaban siempre, aun
// solo para ver la lista de citas — la causa de la carga lenta en iPhone.
const UsuariosTiendaPage = lazy(() => import('../pages/AdminPlatform/Users/UsersAlgolia'))
const EmpresasPage = lazy(() => import('../pages/AdminPlatform/Companies/Companies'))
const TiendasPage = lazy(() => import('../pages/AdminPlatform/Stores/Stores'))
const Calendars = lazy(() => import('../pages/AdminPlatform/Calendars'))
const Pathologies = lazy(() => import('src/pages/AdminPlatform/Pathologies'))
const Processes = lazy(() => import('src/pages/AdminPlatform/Processes'))
const Sectors = lazy(() => import('src/pages/AdminPlatform/Sectors'))
const Areas = lazy(() => import('src/pages/AdminPlatform/Areas'))
const Machines = lazy(() => import('src/pages/AdminPlatform/Machines'))
const Statitics = lazy(() => import('src/pages/AdminPlatform/Statitics'))
const Incidents = lazy(() => import('src/pages/AdminPlatform/Incidents'))
const Campaigns = lazy(() => import('src/pages/AdminPlatform/Campaigns'))
const Hierarchies = lazy(() => import('src/pages/AdminPlatform/Hierarchies'))
const Ayuda = lazy(() => import('src/pages/Ayuda/Ayuda'))
const Utilidades = lazy(() => import('src/pages/Utilidades/Utilidades'))
const Horarios = lazy(() => import('src/pages/Ayuda/Horarios'))
const BookingsRedesign = lazy(() => import('src/pages/AdminPlatform/Bookings/BookingsRedesign'))
const BookingsDetail = lazy(() => import('src/pages/AdminPlatform/Bookings/BookingsDetail'))
const Issues = lazy(() => import('src/pages/AdminPlatform/Issues'))
const IssuesDetail = lazy(() => import('src/pages/AdminPlatform/Issues/IssuesDetail'))
const UsersDetail = lazy(() => import('src/pages/AdminPlatform/Users/UsersDetails'))
const CampaignsDetail = lazy(() => import('src/pages/AdminPlatform/Campaigns/CampaignsDetail'))
const IncidentsDetail = lazy(() => import('src/pages/AdminPlatform/Incidents/IncidentsDetail'))
const Roles = lazy(() => import('src/pages/AdminPlatform/Roles'))
const Chat = lazy(() => import('src/pages/Utilidades/Chat'))
const Encuesta = lazy(() => import('src/pages/Utilidades/Encuesta'))
const ExportarQuerys = lazy(() => import('src/pages/Utilidades/ExportarQuerys'))
const Metaleaves = lazy(() => import('src/pages/Utilidades/Metaleaves'))
const PoliticaPrivacidad = lazy(() => import('src/pages/Ayuda/PoliticaPrivacidad'))
const AvisoLegal = lazy(() => import('src/pages/Ayuda/AvisoLegal'))
const BookingsInterStore = lazy(() => import('src/pages/AdminPlatform/Bookings/BookingsInterStores'))
const BookingSign = lazy(() => import('src/pages/AdminPlatform/Bookings/BookingSign'))
const Sanciones = lazy(() => import('src/pages/Utilidades/Sanciones'))
const WhatsAppLink = lazy(() => import('src/pages/AdminPlatform/WhatsApp'))


const adminRoutes: IRoute[] = [
  {
    path: '/companias',
    name: 'Compañias',
    component: EmpresasPage,
    exact: true,
    roles: ['role1']
  },
  {
    path: '/tiendas',
    name: 'Tiendas',
    component: TiendasPage,
    exact: true,
    roles: ['role1']
  },
  {
    path: '/usuarios',
    name: 'Usuarios',
    component: UsuariosTiendaPage,
    exact: true,
    roles: ['role1', 'role3', 'role4', 'role5']
  },
  // {
  //   path: '/jerarquias',
  //   name: 'Jerarquías',
  //   component: Hierarchies,
  //   exact: true,
  //   roles: ['role1', 'role3', 'role4', 'role5']
  // },
  {
    path: '/usuarios/:idUser',
    name: 'Users-detail',
    component: UsersDetail,
    exact: true,
    roles: ['role1', 'role3', 'role4', 'role5', 'role2']
  },
  {
    path: '/calendarios',
    name: 'Calendars',
    component: Calendars,
    exact: true,
    roles: ['role1', 'role2']
  },
  {
    path: '/puestos',
    name: 'Puestos',
    component: Roles,
    exact: true,
    roles: ['role1', 'role3']
  },
  {
    path: '/estadisticas',
    name: 'Statitics',
    component: Statitics,
    exact: true,
    roles: ['role1', 'role3', 'role4']
  },
  {
    path: '/citas',
    name: 'Bookings',
    component: BookingsRedesign,
    exact: true,
    roles: ['role1', 'role3', 'role4', 'role2', 'role5', 'role6']
  },
  {
    path: '/citas/:idCita',
    name: 'Bookings-detail',
    component: BookingsDetail,
    exact: true,
    roles: ['role1', 'role3', 'role4', 'role5', 'role2']
  },
  {
    path: '/citas/:idCita/confirmar',
    name: 'Booking-sing',
    component: BookingSign,
    exact: true,
    roles: ['role1', 'role3', 'role4', 'role5', 'role2', 'role6']
  },
  {
    path: '/incidentes',
    name: 'Incidents',
    component: Incidents,
    exact: true,
    roles: ['role1', 'role3', 'role4', 'role5', 'role6']
  },
  {
    path: '/incidentes/:idIncident',
    name: 'Incidents-detail',
    component: IncidentsDetail,
    exact: true,
    roles: ['role1', 'role3', 'role4', 'role5', 'role6']
  },
  {
    path: '/campanas',
    name: 'Campaigns',
    component: Campaigns,
    exact: true,
    roles: ['role1', 'role3', 'role4', 'role5']
  },
  {
    path: '/campanas/:idCampaign',
    name: 'Campaigns-detail',
    component: CampaignsDetail,
    exact: true,
    roles: ['role1', 'role3', 'role4', 'role5']
  },
  {
    path: '/patologias',
    name: 'Pathologies',
    component: Pathologies,
    exact: true,
    roles: ['role1']
  },
  {
    path: '/areas',
    name: 'Areas',
    component: Areas,
    exact: true,
    roles: ['role1', 'role3']
  },
  {
    path: '/procesos',
    name: 'Procesos',
    component: Processes,
    exact: true,
    roles: ['role1', 'role3']
  },
  {
    path: '/sectores',
    name: 'Sectores',
    component: Sectors,
    exact: true,
    roles: ['role1', 'role3']
  },
  {
    path: '/maquinaria',
    name: 'Maquinaria',
    component: Machines,
    exact: true,
    roles: ['role1', 'role3']
  },
  /*  {
     path: '/incidencias',
     name: 'Issues',
     component: Issues,
     exact: true,
     roles: ['role1', 'role3', 'role4', 'role2', 'role5']
   }, */
  {
    path: '/interalmacenes',
    name: 'Inter-Almacenes',
    component: BookingsInterStore,
    exact: true,
    roles: ['role1', 'role2', 'role3', 'role4', 'role5']
  },
  /* {
    path: '/incidencias/:idIncidencia',
    name: 'issues-detail',
    component: IssuesDetail,
    exact: true,
    roles: ['role1', 'role3', 'role4', 'role5', 'role2']
  }, */
  {
    path: '/chat',
    name: 'chat',
    component: Chat,
    exact: true,
    roles: ['role1', 'role2', 'role5']
  },
  {
    path: '/encuesta',
    name: 'encuesta',
    component: Encuesta,
    exact: true,
    roles: ['role1', 'role3', 'role4', 'role5', 'role6']
  },
  {
    path: '/exportar-datos',
    name: 'exportar-datos',
    component: ExportarQuerys,
    exact: true,
    roles: ['role1', 'role3', 'role4', 'role5']
  },
  {
    path: '/metaleaves',
    name: 'metaleaves',
    component: Metaleaves,
    exact: true,
    roles: ['role1']
  },
  {
    path: '/ayuda',
    name: 'Ayuda',
    component: Ayuda,
    exact: true,
    roles: ['role1', 'role3', 'role2', 'role4', 'role5', 'role6']
  },
  {
    path: '/utilidades',
    name: 'Utilidades',
    component: Utilidades,
    exact: true,
    roles: ['role1', 'role3', 'role2', 'role4', 'role5', 'role6']
  },
  {
    path: '/politica-de-privacidad',
    name: 'Política de Privacidad',
    component: PoliticaPrivacidad,
    exact: true,
    roles: ['role1', 'role3', 'role2', 'role4', 'role5', 'role6']
  },
  {
    path: '/aviso-legal',
    name: 'Aviso Legal',
    component: AvisoLegal,
    exact: true,
    roles: ['role1', 'role3', 'role2', 'role4', 'role5', 'role6']
  },
  {
    path: '/dias',
    name: 'Dias de Servicio',
    component: Horarios,
    exact: true,
    roles: ['role1', 'role3', 'role2', 'role4', 'role5', 'role6']
  },
  {
    path: '/sanciones',
    name: 'Sanciones',
    component: Sanciones,
    exact: true,
    roles: ['role1', 'role4', 'role5']
  },
  {
    path: '/whatsapp-agente',
    name: 'WhatsApp Agente',
    component: WhatsAppLink,
    exact: true,
    roles: ['role1']
  }
]

export default adminRoutes
